import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../shared/constants/api.constants';
import { RequestCacheService } from '../core/http/request-cache.service';

/** Categories change rarely; 10 minutes keeps navigation instant without going stale for long. */
const CATEGORY_TTL_MS = 10 * 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  constructor(private http: HttpClient, private cache: RequestCacheService) { }

  /** Cached + de-duplicated: home, category, store and store-list pages all need this list. */
  getCategories(): Observable<any> {
    return this.cache.get('categories', CATEGORY_TTL_MS, () => this.http.get(API_ENDPOINTS.CATEGORIES));
  }

  getStores(url?: string): Observable<any> {
    return this.http.get(url ?? API_ENDPOINTS.STORES_V2);
  }

  getStoresByPincode(pincode: string, url?: string) {
    return this.http.get(url ?? API_ENDPOINTS.STORES_WITH_PINCODE_V2 + pincode);
  }
  getStoresByLocation(lat: string, lng: string, radius: string, nextUrl?: string) {

    if (nextUrl) {
      return this.http.get(nextUrl);
    }

    return this.http.get(`${API_ENDPOINTS.STORES_V2}`, {
      params: {
        lat,
        lng,
        radius
      }
    });
  }

}
